export default __webpack_public_path__ + "static/media/noun_Battery_-4.435763f8.svg";